import { Link } from 'react-router-dom';

interface WordmarkProps {
  /** Whether to render as a link to home */
  asLink?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Color variant for dark backgrounds */
  variant?: 'default' | 'light';
}

export function Wordmark({ asLink = true, className = '', variant = 'default' }: WordmarkProps) {
  const content = (
    <span className={`font-display text-[22px] font-normal transition-colors duration-300 ${className}`}>
      LifeDrawing.live
    </span>
  );

  if (asLink) {
    return (
      <Link
        to="/"
        className={`no-underline ${variant === 'light' ? 'text-white' : 'text-text'}`}
      >
        {content}
      </Link>
    );
  }

  return content;
}
